module.exports = __webpack_public_path__ + "img/profile.cad99586.svg";